<template>
  <Icon type="top" :class="['dd-back-top', {'is-show': isShow}]" @click.native="backTop"/>
</template>

<script>
export default {
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      this.isShow = scrollTop > 1000
    },
    backTop () {
      document.body.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
.dd-back-top {
  position: fixed;
  z-index: 9;
  bottom: 50px;
  right: 20px;
  color: #a6a6a6;
  font-size: 36px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all .3s;

  &:hover {
    color: #fff;
  }
  &.is-show {
    visibility: visible;
    opacity: 1;
  }
}
</style>
